import { 
  Factory, 
  ShieldCheck, 
  Sparkles, 
  Truck, 
  Headphones, 
  Leaf, 
  LucideIcon 
} from 'lucide-react';

export interface WhyChooseItem {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export const whyChooseData: WhyChooseItem[] = [
  {
    id: 'state-of-art',
    title: 'In-House Manufacturing',
    description: 'Advanced facility with end-to-end production control for total precision.',
    icon: Factory,
  },
  {
    id: 'quality-control',
    title: 'Strict Quality Control',
    description: 'Multi-stage inspection process guaranteeing perfection in every batch.',
    icon: ShieldCheck,
  },
  {
    id: 'artisan-craftsmanship',
    title: 'Artisan Craftsmanship',
    description: 'Combining traditional artisan skill with modern manufacturing technology.',
    icon: Sparkles,
  },
  {
    id: 'reliable-export',
    title: 'Global Export Logistics',
    description: 'Seamless international door-to-door delivery with customs clearance.',
    icon: Truck,
  },
  {
    id: 'dedicated-support',
    title: 'Dedicated Account Support',
    description: '24/7 personalized support for wholesale and custom OEM orders.',
    icon: Headphones,
  },
  {
    id: 'sustainable',
    title: 'Ethical & Sustainable',
    description: 'Environmentally responsible materials and fair labor certified practices.',
    icon: Leaf,
  },
];